import createIcon from '../../createIcon';

/**
 * @component @name Token
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOTcgNi43MDk3OEwxMiAyLjI3OTc5TDQuMDMgNi43MDk3OEw5LjEgOS41MTk3OEM5LjgzIDguNzU5NzggMTAuODYgOC4yNzk3OSAxMiA4LjI3OTc5QzEzLjE0IDguMjc5NzkgMTQuMTcgOC43NTk3OCAxNC45IDkuNTE5NzhMMTkuOTcgNi43MDk3OFpNMTAgMTIuMjc5OEMxMCAxMS4xNzk4IDEwLjkgMTAuMjc5OCAxMiAxMC4yNzk4QzEzLjEgMTAuMjc5OCAxNCAxMS4xNzk4IDE0IDEyLjI3OThDMTQgMTMuMzc5OCAxMy4xIDE0LjI3OTggMTIgMTQuMjc5OEMxMC45IDE0LjI3OTggMTAgMTMuMzc5OCAxMCAxMi4yNzk4Wk0xMSAyMS43MTk4TDMgMTcuMjc5OFY4LjQxOTc5TDguMTMgMTEuMjY5OEM4LjA0IDExLjU4OTggOCAxMS45Mjk4IDggMTIuMjc5OEM4IDE0LjEzOTggOS4yNyAxNS43MDk4IDExIDE2LjE0OThWMjEuNzE5OFpNMTMgMjEuNzE5OFYxNi4xNDk4QzE0LjczIDE1LjcwOTggMTYgMTQuMTM5OCAxNiAxMi4yNzk4QzE2IDExLjkyOTggMTUuOTYgMTEuNTg5OCAxNS44NyAxMS4yNjk4TDIxIDguNDE5NzlWMTcuMjc5OEwxMyAyMS43MTk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Token = createIcon('Token', [
  [
    'path',
    {
      d: 'M19.97 6.70978L12 2.27979L4.03 6.70978L9.1 9.51978C9.83 8.75978 10.86 8.27979 12 8.27979C13.14 8.27979 14.17 8.75978 14.9 9.51978L19.97 6.70978ZM10 12.2798C10 11.1798 10.9 10.2798 12 10.2798C13.1 10.2798 14 11.1798 14 12.2798C14 13.3798 13.1 14.2798 12 14.2798C10.9 14.2798 10 13.3798 10 12.2798ZM11 21.7198L3 17.2798V8.41979L8.13 11.2698C8.04 11.5898 8 11.9298 8 12.2798C8 14.1398 9.27 15.7098 11 16.1498V21.7198ZM13 21.7198V16.1498C14.73 15.7098 16 14.1398 16 12.2798C16 11.9298 15.96 11.5898 15.87 11.2698L21 8.41979V17.2798L13 21.7198Z',
      key: '1u9xow',
    },
  ],
]);

export default Token;
